(window["webpackJsonpmeg_ui"] = window["webpackJsonpmeg_ui"] || []).push([["alert~back-top~button~drawer~dropdown~flag~form~index~input~menu~message~modal~notification~paginati~756bdcb7"],{

/***/ 22:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _css_animation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39);


var noop = function noop() {};

var getTransitionProps = function getTransitionProps(transitionName) {
  var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var beforeEnter = opt.beforeEnter,
      enter = opt.enter,
      afterEnter = opt.afterEnter,
      leave = opt.leave,
      afterLeave = opt.afterLeave,
      _opt$appear = opt.appear,
      appear = _opt$appear === void 0 ? true : _opt$appear,
      tag = opt.tag,
      nativeOn = opt.nativeOn;
  var transitionProps = {
    props: {
      appear: appear,
      css: false
    },
    on: {
      beforeEnter: beforeEnter || noop,
      enter: enter || function (el, done) {
        Object(_css_animation__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(el, "".concat(transitionName, "-enter"), done);
      },
      afterEnter: afterEnter || noop,
      leave: leave || function (el, done) {
        Object(_css_animation__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(el, "".concat(transitionName, "-leave"), done);
      },
      afterLeave: afterLeave || noop
    },
    nativeOn: nativeOn
  }; // transition-group

  if (tag) {
    transitionProps.tag = tag;
  }

  return transitionProps;
};

/* harmony default export */ __webpack_exports__["a"] = (getTransitionProps);

/***/ })

}]);